import { Button, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useLocales from '#/hooks/useLocales';
import useLocalStorage from '#/lib/hooks/useLocalStorage';

type DownloadSignedDocumentProps = {
  downloadLink: string;
  disabled?: boolean;
};

const DownloadSignedDocument = ({
  downloadLink,
  disabled,
}: DownloadSignedDocumentProps) => {
  const { translate } = useLocales();

  return (
    <Link
      component={RouterLink}
      to={downloadLink}
      target="_blank"
      sx={{
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <Button variant="contained" color="primary" disabled={disabled}>
        <Typography>
          {String(translate('global.dashCardInfos.guest.getDocButton'))}
        </Typography>
      </Button>
    </Link>
  );
};

const ViewService = ({
  toServiceURL,
  ownerID,
  disabled,
}: {
  toServiceURL: string;
  ownerID?: number | string;
  disabled?: boolean;
}) => {
  const { translate } = useLocales();
  const [guestOn] = useLocalStorage('guest_on', '');

  return (
    <Link
      component={RouterLink}
      to={{
        pathname: toServiceURL,
        search: `?invitation_id=${guestOn}`,
      }}
      state={{ ownerID }}
      sx={{
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <Button variant="contained" color="primary" disabled={disabled}>
        <Typography>
          {String(translate('global.dashCardInfos.viewData'))}
        </Typography>
      </Button>
    </Link>
  );
};

export { DownloadSignedDocument, ViewService };
